export default {"src":"/_next/static/media/bank.e1930bd9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};